import { Box, IconButton, Typography } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../assets/icons/minus-colored.svg";

function SelectedFundsContainer({ sx = [], ...props }) {
  const { selectedItems, onItemClick } = props;
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: 76,
        p: "6px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        bgcolor: "grey.7",
        overflow: "auto",
      }}
    >
      {selectedItems.length === 0 ? (
        <Typography
          sx={{ flex: 1 }}
          align="center"
          variant="body2"
          color="grey.2"
        >
          حداکثر 3 صندوق را می‌توانید انتخاب کنید
        </Typography>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {selectedItems.map((fund) => {
            return (
              <Box
                onClick={() => {
                  onItemClick(fund);
                }}
                key={fund.assetId}
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  bgcolor: "common.white",
                  boxShadow: (theme) => theme.shadows[1],
                  mr: 2,
                  position: "relative",
                }}
              >
                <img width={40} height={40} src={fund.fundInfo.iconPath} />
                <IconButton
                  sx={{
                    position: "absolute",
                    top: -10,
                    right: -20,
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

export default SelectedFundsContainer;
